import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CTAButtonProps = {
  label: string;
  id?: string;
  size?: "lg" | "md";
  className?: string;
};
export function CTAButton({
  label,
  id,
  size = "lg",
  className = ""
}: CTAButtonProps) {
  const sizing = size === "lg" ? "px-6 py-5 text-[17px] sm:text-xl" : "px-5 py-4 text-base sm:text-lg";
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-gold-500 ${sizing} text-center font-extrabold uppercase leading-tight tracking-wide text-navy-900 shadow-[0_6px_0_0_#a9842f] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-gold-400 active:translate-y-[4px] active:shadow-[0_2px_0_0_#a9842f] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-300 ${className}`} data-id="element-30" data-mp="2ty1qxxh2pht9">
      <span data-id="element-31" data-mp="38paem11f0t3r">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-32" data-mp="38q3kz0wgpgld" />
    </a>;
}